export const translations = {
    de: {
        competences: 'Projektrelevante Kompetenzen',
        languages: 'Sprachprofil',
        employmentHeader: (num) => `Projekt- und Berufserfahrung ${num}`,
        educationHeader: (num) => `Aus- und Weiterbildung ${num}`,
        unknownSkill: 'Unbekannte Kompetenz',
        unknownLanguage: 'Unbekannte Sprache',
        unknownLevel: 'Unbekanntes Niveau',
        unknownPosition: 'Unbekannte Position',
        unknownCity: 'Unbekannte Stadt',
        unknownCountry: 'Unbekanntes Land',
        privateEquity: 'Private-Equity-Gesellschafter',
        duration: 'Projektdauer',
        location: 'Operative Einsatzorte',
        educationLevel: 'Niveau',
        educationDuration: 'Dauer',
        dossierTitle: 'Kandidaten-Dossier',
        projectRequestFor: 'Projektanfrage für',
        submittedBy: 'Überreicht von | Datum',
        contactDetails: 'Kontaktdaten',
        contactPerson: 'Ansprechpartner',
        for: 'für',
        disclaimer: `Wichtiger Hinweis: Dieser Lebenslauf wurde durch :groupName überreicht. Sollte Ihnen der Kandidat bereits bekannt sein, ist es der :groupName sofort mit einer Begründung mitzuteilen. Des Weiteren darf der Kandidat nicht direkt angesprochen werden. Für den Fall, dass keine Beauftragung erfolgt, sind sämtliche Daten unverzüglich zu löschen. Die hierin übermittelten Daten sind personenbezogene, geschützte Daten i.S.d. DSGVO/des BDSG und des Bundesgesetzes über den Datenschutz (DSG) der Schweiz und sind streng vertraulich und ausschließlich zum Zweck einer Qualifikationsprüfung zu verwenden. Hierin enthaltene Informationen dürfen nur zum Zwecke der Vertragsdurchführung genutzt und nicht an Dritte übermittelt werden. Ein :violation dagegen kann neben zivilrechtlichen Ansprüchen auch Bussgeldansprüche nach sich ziehen und ggf. sogar strafbar sein.`,
        yearOfBirth: 'Geburtsjahr',
        regionOfResidence: 'Region/Wohnort',
        ongoing: 'laufend',
        notSpecified: 'keine Angaben',
    },
    en: {
        competences: 'Project-relevant competences',
        languages: 'Language profile',
        employmentHeader: (num) => `Project and Work Experience ${num}`,
        educationHeader: (num) => `Education and Training ${num}`,
        unknownSkill: 'Unknown skill',
        unknownLanguage: 'Unknown language',
        unknownLevel: 'Unknown level',
        unknownPosition: 'Unknown position',
        unknownCity: 'Unknown city',
        unknownCountry: 'Unknown country',
        privateEquity: 'Private Equity Shareholder',
        duration: 'Project Duration',
        location: 'Operational Locations',
        educationLevel: 'Level',
        educationDuration: 'Duration',
        dossierTitle: 'Candidate Dossier',
        projectRequestFor: 'Project request for',
        submittedBy: 'Submitted by | Date',
        contactDetails: 'Contact details',
        contactPerson: 'Contact person',
        for: 'for',
        disclaimer: `Important Notice: This resume is presented to you by :groupName. In case you already know the candidate, you are obliged to immediately notify the :groupName on this fact. In addition, the candidate must not be contacted directly. If no assignment is made, all data must be deleted immediately. The conveyed personal data, protected by the General Data Protection Regulation, GDPR, BDSG and the Federal Act on Data Protection (FADP) of Switzerland are strongly confidential and are to be used for the purpose of qualification assessment of the candidate only. Herein contented information may only be used for the purpose of the performance of the contract and may not be passed on to third parties. Infringement is not only liable for civil claims but may also lead to administrative fines or even criminal prosecution.`,
        yearOfBirth: 'Year of birth',
        regionOfResidence: 'Region/Residence',
        ongoing: 'ongoing',
        notSpecified: 'not specified',
    }
};